import createLucideIcon from '../createLucideIcon';

const Construction = createLucideIcon('Construction', [
  [
    'path',
    {
      d: 'M21 6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H21C21.5523 14 22 13.5523 22 13V7C22 6.44772 21.5523 6 21 6Z',
      key: 'scmm9l',
    },
  ],
  ['path', { d: 'M17 14V21', key: 'hjiiw1' }],
  ['path', { d: 'M7 14V21', key: '1c8u6p' }],
  ['path', { d: 'M17 3V6', key: '16iunk' }],
  ['path', { d: 'M7 3V6', key: '1trbls' }],
  ['path', { d: 'M2.5 6.5L10 14', key: 'wvyfsr' }],
  ['path', { d: 'M8 6L16 14', key: '1wcjn0' }],
  ['path', { d: 'M14 6L21.5 13.5', key: '1db8iv' }],
]);

export default Construction;
